// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** /core/client/rawr/style/BoxShadow.scss
 ** module id = 939
 ** module chunks = 1 2 4 7
 **/